import { render, staticRenderFns } from "./changeInformation-detail.vue?vue&type=template&id=a3fd5bf4&scoped=true"
import script from "./changeInformation-detail.vue?vue&type=script&lang=js"
export * from "./changeInformation-detail.vue?vue&type=script&lang=js"
import style0 from "./changeInformation-detail.vue?vue&type=style&index=0&id=a3fd5bf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fd5bf4",
  null
  
)

export default component.exports